import {
  IsArray,
  IsEnum,
  IsIn,
  IsMongoId,
  IsNotEmpty,
  IsOptional,
  IsString,
  MaxLength
} from "class-validator";
import { QualityDocumentOrderType } from "./quality-document-order-type";

// fix me: add UNIT TESTS for validation
export class ConsultantReassignBAPayload {
  @IsArray()
  @IsMongoId({ each: true })
  consultantIds: string[];

  @IsMongoId()
  @IsOptional()
  baId: string | null;
}

// fix me: add UNIT TESTS for validation
export class ConsultantSmsPayload {
  @IsArray()
  @IsMongoId({ each: true })
  consultantIds: string[];

  @IsString()
  @IsNotEmpty()
  @MaxLength(750)
  message: string;

  // Communication sub-type chosen in the UI (Information / JobMailing / Marketing). Maps to the
  // send-time consent purpose in the worker. Optional for backward compatibility — legacy payloads
  // without it are treated as JobMailing. Mirrors `BulkActionCommunicationSubType` in
  // @bonliva-crm/shared (kept as a string here to avoid a common → shared dependency cycle).
  @IsOptional()
  @IsIn(["Information", "JobMailing", "Marketing"])
  subType?: string;
}

// fix me: add UNIT TESTS for validation
export class ConsultantEmailPayload {
  @IsArray()
  @IsMongoId({ each: true })
  consultantIds: string[];

  @IsString()
  @IsNotEmpty()
  subject: string;

  @IsString()
  @IsNotEmpty()
  body: string;

  @IsArray()
  @IsMongoId({ each: true })
  attachmentIds: string[];

  // Communication sub-type chosen in the UI (Information / JobMailing / Marketing). Maps to the
  // send-time consent purpose in the worker. Optional for backward compatibility — legacy payloads
  // without it are treated as JobMailing. Mirrors `BulkActionCommunicationSubType` in
  // @bonliva-crm/shared (kept as a string here to avoid a common → shared dependency cycle).
  @IsOptional()
  @IsIn(["Information", "JobMailing", "Marketing"])
  subType?: string;
}

// fix me: add UNIT TESTS for validation
export class ConsultantAssignCallListPayload {
  @IsArray()
  @IsMongoId({ each: true })
  consultantIds: string[];

  @IsArray()
  @IsMongoId({ each: true })
  callContactListIds: string[];
}

// fix me: add UNIT TESTS for validation
export class ConsultantDeletePayload {
  @IsArray()
  @IsMongoId({ each: true })
  consultantIds: string[];
}

// fix me: add UNIT TESTS for validation
export class ConsultantAssignTagsPayload {
  @IsArray()
  @IsMongoId({ each: true })
  consultantIds: string[];

  @IsArray()
  @IsString({ each: true })
  tags: string[];
}

export class ConsultantOrderQualityDocumentsPayload {
  @IsArray()
  @IsMongoId({ each: true })
  consultantIds: string[];

  @IsEnum(QualityDocumentOrderType)
  @IsNotEmpty()
  qualityDocumentType: QualityDocumentOrderType;
}
